var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Thêm thẻ mới",
            "before-close": _vm.handleClose,
            visible: _vm.isOpen,
            "show-close": true,
            "close-on-click-modal": false,
            width: "600px",
            top: "10vh",
            "custom-class": "modern-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpen = $event
            },
            open: _vm.handleOpen,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "dialog-footer-themed" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            plain: "",
                            size: "medium",
                            icon: "el-icon-circle-close",
                          },
                          on: { click: _vm.handleClose },
                        },
                        [_vm._v("\n          Đóng\n        ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            size: "medium",
                            icon: "el-icon-circle-check",
                            loading: _vm.loading.submit,
                          },
                          on: { click: _vm.submitForm },
                        },
                        [_vm._v("\n          Lưu lại\n        ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "dialog-header-themed" }, [
            _c("div", { staticClass: "themed-icon" }, [
              _c("i", { staticClass: "el-icon-bank-card" }),
            ]),
            _c("div", { staticClass: "themed-text" }, [
              _c("h3", [_vm._v("THÊM THẺ NHẬN DIỆN MỚI")]),
              _c("p", [
                _vm._v(
                  "Chọn trường học, thiết bị AI đọc thẻ và quét số thẻ để tạo mới thông tin."
                ),
              ]),
            ]),
          ]),
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "modern-dialog-form",
              attrs: {
                "label-position": "top",
                model: _vm.formData,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "div",
                { staticClass: "form-section" },
                [
                  _c("h4", { staticClass: "section-divider" }, [
                    _c("i", { staticClass: "el-icon-setting" }),
                    _vm._v(" Cấu hình gán thẻ"),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Chọn trường học liên kết" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "w-full",
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "Chọn trường",
                                  },
                                  model: {
                                    value: _vm.formData.idSchool,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "idSchool", $$v)
                                    },
                                    expression: "formData.idSchool",
                                  },
                                },
                                _vm._l(_vm.schoolList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      value: item.id,
                                      label: `${item.id} - ${item.schoolName}`,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Chọn thiết bị AI đọc thẻ",
                                prop: "idDevice",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "w-full",
                                  attrs: {
                                    filterable: "",
                                    placeholder:
                                      "Chọn thiết bị nhận diện đọc thẻ",
                                  },
                                  on: { change: _vm.getUserRecognition },
                                  model: {
                                    value: _vm.formData.idDevice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "idDevice", $$v)
                                    },
                                    expression: "formData.idDevice",
                                  },
                                },
                                _vm._l(_vm.listDevice, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      value: item.id,
                                      label: `${item.id} - ${item.nameDevice}`,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-section" },
                [
                  _c("h4", { staticClass: "section-divider" }, [
                    _c("i", { staticClass: "el-icon-cpu" }),
                    _vm._v(" Quét mã số thẻ (RFID)"),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Mã số thẻ quét được",
                                prop: "cardNumber",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "card-number-input",
                                attrs: {
                                  readonly: "",
                                  placeholder:
                                    "Click nút 'Đọc thẻ' và quét thẻ từ trên thiết bị...",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "read-card-btn",
                                            attrs: { type: "primary" },
                                            on: {
                                              click: _vm.handleGetNumberCard,
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-radar",
                                            }),
                                            _vm._v(
                                              " Đọc thẻ từ\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.formData.cardNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "cardNumber",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formData.cardNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Quét thẻ nhận diện",
            visible: _vm.showWarning,
            width: "420px",
            top: "25vh",
            "show-close": true,
            "custom-class": "radar-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showWarning = $event
            },
          },
        },
        [
          _c("div", { staticClass: "radar-container" }, [
            _c("div", { staticClass: "radar-signal-rings" }, [
              _c("div", { staticClass: "ring ring-1" }),
              _c("div", { staticClass: "ring ring-2" }),
              _c("div", { staticClass: "ring ring-3" }),
              _c("div", { staticClass: "radar-center-icon" }, [
                _c("i", { staticClass: "el-icon-bank-card" }),
              ]),
            ]),
            _c("div", { staticClass: "radar-status-info" }, [
              _c("h4", [_vm._v(_vm._s(_vm.contentDevice))]),
              _c("p", [
                _vm._v(
                  "Hãy chạm thẻ từ của bạn vào vùng cảm biến RFID trên thiết bị AI để hệ thống tự động ghi nhận mã số thẻ."
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }